import React, { useState, useEffect, memo, Fragment, useMemo } from "react";
import { Row, Col, Form } from "react-bootstrap";
import Card from "../../../components/Card";
import DashboardService from "../../../services/pbumku/DashboardService";

// apexcharts
import Chart from "react-apexcharts";

// swiper
import SwiperCore, { Navigation } from "swiper";
import "swiper/swiper-bundle.min.css";

// Count-up
import CountUp from "react-countup";

SwiperCore.use([Navigation]);

const Reportppm = memo(() => {
  const [frequensi, setFrequensi] = useState([]);
  const [isNol, setIsNol] = useState(false);
  const [jumfreq, setJumfreq] = useState(0);
  const [jumVol, setJumVol] = useState(0);
  const [nilaiIDR, setNilaiIDR] = useState(0);
  const [nilaiUSD, setNilaiUSD] = useState(0);
  const [kdUPT] = useState("00.1");
  const [bentuk, setBentuk] = useState([]);
  const today = new Date();
  const month = today.getMonth(); // 0-11
  const year = today.getFullYear();
    const [startOfMonth, setStartOfMonth] = useState(new Date(year, month, 1));
    const [endOfMonth, setEndOfMonth] = useState(new Date(year, month + 1, 0));
  const monthNames = [  
    "Januari", "Februari", "Maret", "April", "Mei", "Juni",
    "Juli", "Agustus", "September", "Oktober", "November", "Desember"
  ];

  const [bulanTerpilih, setBulanTerpilih] = useState("all");

  const getStartDate = () => {
    return bulanTerpilih === "all"
      ? new Date(year, 0, 1)
      : new Date(year, parseInt(bulanTerpilih), 1);
  };

  const getEndDate = () => {
    return bulanTerpilih === "all"
      ? new Date(year, 11, 31)
      : new Date(year, parseInt(bulanTerpilih) + 1, 0);
  };

  const formatDate = (date, isEndOfDay = false) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const time = isEndOfDay ? "23:59:59" : "00:00:00";
    return `${yyyy}-${mm}-${dd} ${time}`;
  };

  const DashService = useMemo(() => new DashboardService(), []);

  const getJumlahFrequensi = async () => {
    const response = await DashService.getJumlahFrequensi(
      kdUPT,
      formatDate(getStartDate()),
      formatDate(getEndDate(), true)
    );
    setJumfreq(response.data);
    setIsNol(response.data === 0);
  };

  const getJumlahVolume = async () => {
    const response = await DashService.getJumlahVolume(
      kdUPT,
      formatDate(getStartDate()),
      formatDate(getEndDate(), true)
    );
    setJumVol(response.data.totalVolume);
  };

  const getNilai = async () => {
    const response = await DashService.getJumlahNilai(
      kdUPT,
      formatDate(getStartDate()),
      formatDate(getEndDate(), true)
    );
    setNilaiIDR(response.data.totalNilaiIDR);
    setNilaiUSD(response.data.totalNilaiUSD);
  };

  const getKetBentuk = async () => {
    const response = await DashService.getKetBentuk(
      kdUPT,
      formatDate(getStartDate()),
      formatDate(getEndDate(), true)
    );
    setBentuk(response.data);
  };
const getFrequensi = async () => {
  const response = await DashService.getFrequensiBulan(
    kdUPT,
    formatDate(getStartDate()),
    formatDate(getEndDate(), true)
  );
  console.log("FREQUENSI RESPONSE:", response.data);
  setFrequensi(response.data);
};

  useEffect(() => {
    if (DashService && kdUPT) {
      getJumlahFrequensi();
      getJumlahVolume();
      getNilai();
      getFrequensi();
      getKetBentuk();
    }
  }, [bulanTerpilih]);

  const colors = ["#7366ff", "#ffcc5b"];

  const chartFrequensi = useMemo(() => {
    if (!frequensi?.length) return null;

    return {
      options: {
        chart: { sparkline: { enabled: false } },
        colors,
        dataLabels: { enabled: false },
        stroke: { curve: "smooth", width: 3 },
        xaxis: {
          categories: frequensi?.map(item => monthNames[item?.BULAN - 1])
        },
        tooltip: {
          x: {
            formatter: val => `Bulan ${val}`
          }
        }
      },
      series: [
        {
          name: "Jumlah",
          data: frequensi?.map(item => item?.JUMLAH ?? 0)
        }
      ]
    };
  }, [frequensi]);


const chartVolume = useMemo(() => {
  if (!frequensi?.length) return null;

  return {
    options: {
      chart: { stacked: true },
      colors,
      stroke: { show: true, width: 2 },
      xaxis: {
        categories: frequensi?.map(item => monthNames[item?.BULAN - 1])
      },
      dataLabels: { enabled: false },
      tooltip: {
        x: { formatter: val => `Bulan ${val}` },
        y: {
          formatter: val => (val ?? 0).toLocaleString("id-ID") + " Ton"
        }
      }
    },
    series: [
      {
        name: "Volume (Ton)",
        data: frequensi?.map(item => (item?.NETTO ?? 0) / 1000)
      }
    ]
  };
}, [frequensi]);


  const chartBentuk = useMemo(() => {
    if (!bentuk?.length) return null;
    return {
      options: {
        labels: bentuk?.filter(item => item.ket_bentuk).map(item => item.ket_bentuk),
        chart: { type: "donut" },
        tooltip: { y: { formatter: val => `${val.toLocaleString("id-ID")} Ton` } }
      },
      series: bentuk?.filter(item => item.ket_bentuk).map(item => item.totalVolume / 1000)
    };
  }, [bentuk]);

  return (
    <Fragment>
      <Row className="mb-4 px-4 py-3 rounded bg-soft-info">
        <Col>
        <h2>Statistik SMKHP</h2>
        <h3>Tahun {year}</h3>
        </Col>
        {/* <Col md="2">
          <Form.Select value={bulanTerpilih} onChange={(e) => setBulanTerpilih(e.target.value)}>
            <option value="all">Semua Bulan</option>
            {monthNames.map((bulan, index) => (
              <option key={index} value={index}>{bulan}</option>
            ))}
          </Form.Select>
        </Col> */}
      </Row>

      {/* Statistik Cards */}
      <Row>
        <Col lg="3" md="6">
          <Card>
            <Card.Body className="d-flex justify-content-between align-items-center">
              <div className="bg-info text-white rounded p-3"></div>
              <div className="text-end">
                Frekuensi
                <h2>
                  <CountUp start={isNol ? 0 : (jumfreq ?? 0) - 20} end={jumfreq ?? 0} duration={3} formattingFn={val => (val ?? 0).toLocaleString('id-ID')} />
                </h2>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col lg="3" md="6">
          <Card>
            <Card.Body className="d-flex justify-content-between align-items-center">
              <div className="bg-warning text-white rounded p-3"></div>
              <div className="text-end">
                Volume (Ton)
                <h2>
                  <CountUp start={isNol ? 0 : (jumVol ?? 0) / 1000 - 20} end={(jumVol ?? 0) / 1000} duration={3} formattingFn={val => val.toLocaleString('id-ID')} decimals={2} />
                </h2>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col lg="3" md="6">
          <Card>
            <Card.Body className="d-flex justify-content-between align-items-center">
              <div className="bg-success text-white rounded p-3"></div>
              <div className="text-end">
                Nilai IDR (Juta)
                <h2>
                  <CountUp start={isNol ? 0 : (nilaiIDR ?? 0) / 1000000 - 20} end={(nilaiIDR ?? 0) / 1000000} duration={3} formattingFn={val => val.toLocaleString('id-ID')} decimals={2} />
                </h2>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col lg="3" md="6">
          <Card>
            <Card.Body className="d-flex justify-content-between align-items-center">
              <div className="bg-danger text-white rounded p-3"></div>
              <div className="text-end">
                Nilai USD
                <h2 >
                  <CountUp start={isNol ? 0 : (nilaiUSD ?? 0) - 20} end={nilaiUSD ?? 0} duration={3} formattingFn={val => val.toLocaleString('id-ID')} decimals={2} />
                </h2>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Charts */}
      <Row className="mt-2">
        <Col md="4">
          <Card>
            <Card.Body>
              <h5>Frekuensi</h5>
              {chartFrequensi ? <Chart options={chartFrequensi.options} series={chartFrequensi.series} type="area" height="260" /> : <div>Memuat...</div>}
            </Card.Body>
          </Card>
        </Col>

        <Col md="4">
          <Card>
            <Card.Body>
              <h5>Volume</h5>
              {chartVolume ? <Chart options={chartVolume.options} series={chartVolume.series} type="bar" height="260" /> : <div>Memuat...</div>}
            </Card.Body>
          </Card>
        </Col>

        <Col md="4">
          <Card>
            <Card.Body>
              <h5>Volume Bentuk Komoditas</h5>
              {chartBentuk ? <Chart options={chartBentuk.options} series={chartBentuk.series} type="donut" height="270" /> : <div>Memuat...</div>}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
});

export default Reportppm;
